'use client';

import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ToggleInput from '@nib-components/toggle-input';
const RadioButton = props => /*#__PURE__*/_jsx(ToggleInput, {
  ...props,
  type: "radio",
  hideInput: true,
  "data-mesh-component": "RADIO-BUTTON"
});
RadioButton.displayName = 'RadioButton';
export default RadioButton;